<template>
	<div class="app-container">
	  
	  
	  <!-- 顶部标题栏 -->
	  <div class="header-bar">
		<button @click="goBack" class="back-btn"><i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow" style="font-size: 10px !important;"></i></button>
		<div class="title-center">
		  <div class="subtitle">{{ $t('certification.certOrderNo') }}</div>
		  <div class="main-title">{{ displayOrderSn }}</div>
		</div>
		<button class="record-btn" @click="goToRecord">
		  <span></span>{{ $t('certification.record') }}
		</button>
	  </div>
	  
	  <!-- 背景图（模糊） -->
	  <div class="bg-image"></div>
	  
	  <!-- 中心认证区域和产品 -->
	  <div class="auth-wrapper">
		<!-- 成功提示横幅 -->
		<div v-if="showSuccessNotify" class="success-notify">
			<div class="success-icon">✓</div>
			<div class="success-text">
			{{ $t('certification.certSuccess', { orderNo: successData.orderNo, deducted: successData.deducted, balance: successData.balance }) }}
			</div>
		</div>
		<!-- 中心认证按钮 -->
		<div class="center-auth">
			<div class="auth-circle">
			<div class="shield-icon">️</div>
			<div class="auth-text">{{ getCertTypeText() }}</div>
			<div class="time-label">{{ $t('certification.timeRemaining') }}</div>
			<div class="countdown" :class="{ 'countdown-zero': countdown === '00:00:00' }">{{ countdown }}</div>
			<div v-if="countdown === '00:00:00'" class="refresh-tip">{{ $t('certification.reviewTimeout') }}</div>
		  </div>
		</div>
		
		<!-- 四个产品 - 围绕中心圆形排列 -->
		<!-- 上方左侧： -->
		<div 
		  class="action-item product-top-left" 
		  :class="{ active: selectedProducts.includes(1) }"
		  @click="toggleProduct(1)"
		>
		  <img :src="quickActions[0].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[0].label }}</div>
		</div>
		<!-- 上方右侧： -->
		<div 
		  class="action-item product-top-right" 
		  :class="{ active: selectedProducts.includes(2) }"
		  @click="toggleProduct(2)"
		>
		  <img :src="quickActions[1].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[1].label }}</div>
		</div>
		<!-- 下方左侧： -->
		<div 
		  class="action-item product-bottom-left" 
		  :class="{ active: selectedProducts.includes(3) }"
		  @click="toggleProduct(3)"
		>
		  <img :src="quickActions[2].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[2].label }}</div>
		</div>
		<!-- 下方右侧： -->
		<div 
		  class="action-item product-bottom-right" 
		  :class="{ active: selectedProducts.includes(4) }"
		  @click="toggleProduct(4)"
		>
		  <img :src="quickActions[3].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[3].label }}</div>
		</div>
	  </div>
  
	  
  
	  <!-- 积分输入区域 -->
	  <div class="points-section">
		
		<input
		  v-model.number="selectedPoints"
		  type="number"
		  min="0"
		  max="6680"
		  class="points-input"
		  :placeholder="$t('certification.enterPoints')"
		/>
		<div class="info-row">
		  {{ $t('certification.selectedItems', { count: selectedItems }) }}<br />
		  {{ $t('certification.estimatedDeduct', { amount: totalBetAmount }) }}
		</div>
		<div class="balance-btn-row">
		  <div class="balance-row">
			<span>{{ $t('certification.totalAmount') }}</span>
			<span class="balance-value">{{ totalBalance }} {{ $t('certification.points') }}</span>
		  </div>
		  <div class="balance-row">
			<span>{{ $t('certification.availableAmount') }}</span>
			<span class="balance-value">{{ accountBalance }} {{ $t('certification.points') }}</span>
		  </div>
		  <button @click="confirmAuth" class="confirm-btn">
			<span>✔️</span>{{ $t('certification.confirmCert') }}
		  </button>
		</div>
		<!-- 步骤表已废弃，不再显示订单步骤进度 -->
	  </div>
	  <!-- 底部导航栏 -->
	  <!-- <div class="footer-nav">
		<button v-for="tab in tabs" :key="tab.name" @click="switchTab(tab.name)" class="nav-item" :class="{ active: activeTab === tab.name }">
		  <div class="nav-icon">{{ tab.icon }}</div>
		  <div class="nav-text">{{ tab.text }}</div>
		</button>
	  </div> -->
	</div>
  </template>
  
  <script>
  export default {
		name: 'App',
		data() {
		return {
			countdown: '48:00:00',
			timer: null,
			selectedPoints: '',
			selectedItems: 0,
			selectedProducts: [],
			accountBalance: 0, // available balance
			activeTab: '',
			lottery: {},
			xuanfeiData: {},
			lottery_id: null,
			userInfo: {},
			lottery_peilv_list: [],
			formData: [],
			certType: null, // 认证类型：car, hotel, confidential
			currentOrder: null, // 当前订单信息（步骤表已废弃，仅保留兼容）
			orderConfig: null, // 订单配置
			showSuccessNotify: false,
			successData: {
			orderNo: '',
			deducted: 0,
			balance: 0
			},
			notifyTimer: null,
			// 头部展示并传给接口的随机订单号（进入页与每次下单前生成）
			headerOrderSn: '',
			// 商品映射到大小单双：1=大, 2=小, 3=单, 4=双
			productTypeMap: {},
			quickActions: [],
			tabs: []
		}
		},
		computed: {
		displayOrderSn() {
			return this.headerOrderSn || (this.currentOrder && this.currentOrder.order_sn) || '--'
		},
		totalBetAmount() {
			if (!this.selectedPoints || this.formData.length === 0) {
			return 0
			}
			return this.formData.length * this.selectedPoints
		},
		totalBalance() {
			const money = Number(this.userInfo.money || 0)
			const freeze = Number(this.userInfo.freeze_money || 0)
			return money + freeze
		}
		},
		mounted() {
		// 初始化tabs
		this.tabs = [
			{ name: 'Home', icon: 'ℹ️', text: this.$t('common.home') || 'Home' },
			{ name: 'Video', icon: '▶️', text: this.$t('common.video') || 'Video' },
			{ name: 'Choose', icon: '❤️', text: this.$t('common.choose') || 'Choose' },
			{ name: 'Pl', icon: '⭐', text: this.$t('common.review') || 'Review' },
			{ name: 'Mine', icon: '', text: this.$t('common.my') || 'My' }
		]
		// 初始化商品类型映射
		this.productTypeMap = {
			1: { type: this.$t('game.da'), name: 'da' },
			2: { type: this.$t('game.xiao'), name: 'xiao' },
			3: { type: this.$t('game.dan'), name: 'dan' },
			4: { type: this.$t('game.shuang'), name: 'shuang' }
		}
		// 初始化商品列表
		this.quickActions = [
			{ label: this.$t('certification.product1'), icon: '/img/v1.png' },
			{ label: this.$t('certification.product2'), icon: '/img/v2.png' },
			{ label: this.$t('certification.product3'), icon: '/img/v3.png' },
			{ label: this.$t('certification.product4'), icon: '/img/v4.png' }
		]
		// 不再从路由参数获取认证类型，而是根据订单进度自动判断
		this.initData()
		},
		methods: {
		
		// 生成随机订单号（头部展示并传给接口）
		generateOrderSn() {
			const d = new Date();
			const pad2 = (n) => String(n).padStart(2, '0');
			const ts =
				String(d.getFullYear()) +
				pad2(d.getMonth() + 1) +
				pad2(d.getDate()) +
				pad2(d.getHours()) +
				pad2(d.getMinutes()) +
				pad2(d.getSeconds()); // YYYYMMDDHHIISS
			// 追加 4 位随机数字，避免同秒重复
			const rand = String(Math.floor(Math.random() * 9000) + 1000);
			return 'ORD' + ts + rand;
		},
		// 执行单次下注。products 为实际商品名称数组（如 [催情水, 润滑油]）
		async placeSingleBet(beautyId, selectedPoints, products) {
			const betData = {
				order_sn: this.headerOrderSn,
				item: Array.isArray(products) ? products.join(',') : '',
				money: selectedPoints,
				beauty_id: beautyId,
				certType: this.certType,
				lid: 10  // 使用默认的彩票ID，后端可能需要这个参数
			};
			
			try {
			const res = await this.$http({
				method: 'get',
				url: 'create_order',
				data: betData
			});
			return res;
			} catch (error) {
			console.error('下注失败:', error);
			return null;
			}
		},
		
		initData() {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' })
				return
			}
			this.certType = this.$route.query.certType;
			this.headerOrderSn = this.generateOrderSn();
			this.getUserInfo()
			this.startCountdown()
			// 倒计时改为在 getCurrentOrder 回调中根据订单 create_time 启动，不再依赖彩票
		},
		getUserInfo() {
			this.$http({
			method: 'get',
			url: 'user_info'
			}).then(res => {
			if (res.code === 200) {
				this.userInfo = res.data
				this.accountBalance = res.data.money || 0
			}
			})
		},
		startCountdown() {
			if (this.timer) clearInterval(this.timer)
			this.timer = setInterval(() => {
			const parts = this.countdown.split(':').map(Number)
			let totalSec
			if (parts.length >= 3) {
				totalSec = parts[0] * 3600 + parts[1] * 60 + parts[2]
			} else {
				totalSec = (parts[0] || 0) * 60 + (parts[1] || 0)
			}
			if (totalSec <= 0) {
				this.countdown = '00:00:00'
				// 倒计时结束刷新用户信息即可（步骤表已废弃）
				this.getUserInfo()
			} else {
				totalSec -= 1
				const hours = Math.floor(totalSec / 3600)
				const newMin = Math.floor((totalSec % 3600) / 60)
				const newSec = totalSec % 60
				this.countdown = `${String(hours).padStart(2, '0')}:${String(newMin).padStart(2, '0')}:${String(newSec).padStart(2, '0')}`
			}
			}, 1000)
		},
		async confirmAuth() {
			// 验证输入（不再在这里创建订单，由后台在首次下注时按需创建）
			if (!this.selectedPoints || this.selectedPoints <= 0) {
			this.$toast(this.$t('certification.enterPointsFirst'))
			return
			}
			
			// 验证余额是否足够
			if (this.accountBalance < this.selectedPoints) {
			this.$toast(this.$t('certification.insufficientBalance'))
			return
			}
			
			// 无论当前是否已有订单，都直接请求下注。
			// 后端若发现还没有订单，会在 GameModel::placeOrder 里按需创建订单。
			await this.executeBet(0, this.selectedPoints);
		},
		
		// 执行单次下注（用户手动操作）
		async executeBet(beautyId, selectedPoints) {
			// 将已选商品 ID 转为实际商品名称数组（与页面展示一致）
			const productNames = this.selectedProducts
				.map(id => this.quickActions[id - 1] && this.quickActions[id - 1].label)
				.filter(Boolean);
			if (productNames.length === 0) {
				this.$toast.fail(this.$t('certification.enterPoints') || '请先选择商品');
				return;
			}
			// 本次下单使用新的随机订单号，并传给接口
			this.headerOrderSn = this.generateOrderSn();
			try {
			// 执行单次下注，传递实际商品名称数组
			const result = await this.placeSingleBet(beautyId, selectedPoints, productNames);
			
			if (result && result.code === 200) {
				// 下单成功：展示成功提示
				const data = result.data || {};
				const deducted = (this.selectedPoints || 0) * productNames.length;
				const orderNo = data.order_sn || data.orderNo || this.headerOrderSn;
				this.successData = {
					orderNo,
					deducted,
					balance: data.balance !== undefined ? data.balance : this.accountBalance
				};
				this.headerOrderSn = orderNo; // 头部与接口返回保持一致
				this.showSuccessNotify = true;
				if (this.notifyTimer) clearTimeout(this.notifyTimer);
				this.notifyTimer = setTimeout(() => {
					this.showSuccessNotify = false;
				}, 3000);
				this.getUserInfo();
				this.$toast.success(this.$t('certification.certSuccess', this.successData) || '下单成功');
			} else {
				this.$toast.fail(result?.msg || this.$t('certification.betFailed'));
			}
			} catch (error) {
				console.error('下注过程出错:', error);
				this.$toast.fail(this.$t('certification.betProcessError'));
			}
		},
		allClear() {
			this.selectedProducts = []
			this.formData = []
			this.selectedItems = 0
			this.selectedPoints = ''
		},
		goBack() {
			return window.history.back();
		},
		goToRecord() {
			// 传递 lottery_id 参数
			const query = {}
			if (this.lottery_id) {
			query.lottery_id = this.lottery_id
			}
			this.$router.push({ 
			path: '/CertificationRecord',
			query: query
			})
		},
		switchTab(tabName) {
			this.activeTab = tabName
			const query = {}
			this.$router.push({
			path: '/'+ tabName,
			query: query
			})
		},
		toggleProduct(productId) {
			// 商品1、2、3、4对应大小单双
			const productType = this.productTypeMap[productId]
			if (!productType) return
			
			const index = this.selectedProducts.indexOf(productId)
			if (index > -1) {
			// 取消选择
			this.selectedProducts.splice(index, 1)
			// 从 formData 中移除
			for (let i = 0; i < this.formData.length; i++) {
				if (productType.type === this.formData[i]['type']) {
				this.formData.splice(i, 1)
				break
				}
			}
			} else {
			// 选择
			this.selectedProducts.push(productId)
			// 添加到 formData
			this.formData.push({
				name: productType.name,
				type: productType.type
			})
			}
			this.selectedItems = this.formData.length
		},
		getCertTypeText() {
			// 根据认证类型返回对应的文本
			const certTypeMap = {
			'car': this.$t('certification.carCert'),
			'hotel': this.$t('certification.hotelCert'),
			'confidential': this.$t('certification.confidentialCert')
			}
			return certTypeMap[this.certType] || this.$t('certification.carCert')
		},
		beforeDestroy() {
		if (this.timer) clearInterval(this.timer)
		if (this.notifyTimer) clearTimeout(this.notifyTimer)
		}
		}
	}
  </script>
  
  <style scoped>
  .app-container {
	position: relative;
	min-height: 100vh;
	background: #000;
	color: white;
	overflow-y: auto;
	overflow-x: hidden;
	font-family: Arial, sans-serif;
	/* 隐藏滚动条但保持滚动功能 */
	scrollbar-width: none !important; /* Firefox */
	-ms-overflow-style: none !important; /* IE 和 Edge */
  }
  
  /* 隐藏滚动条但保持滚动功能 - Chrome, Safari, Opera */
  .app-container::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
	background: transparent !important;
	display: none !important;
  }
  
  .app-container::-webkit-scrollbar-track {
	display: none !important;
  }
  
  .app-container::-webkit-scrollbar-thumb {
	display: none !important;
  }
  
  /* 如果需要显示细滚动条，可以使用以下样式替代上面的隐藏样式 */
  /*
  .app-container::-webkit-scrollbar {
	width: 4px;
  }
  
  .app-container::-webkit-scrollbar-track {
	background: rgba(0, 0, 0, 0.1);
	border-radius: 2px;
  }
  
  .app-container::-webkit-scrollbar-thumb {
	background: rgba(236, 72, 153, 0.5);
	border-radius: 2px;
  }
  
  .app-container::-webkit-scrollbar-thumb:hover {
	background: rgba(236, 72, 153, 0.8);
  }
  */
  
  /* 成功提示横幅 */
  .success-notify {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	background: #00c853;
	color: white;
	padding: 16px 20px;
	display: flex;
	align-items: center;
	gap: 12px;
	z-index: 9999;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
	animation: slideDown 0.3s ease-out;
  }
  
  @keyframes slideDown {
	from {
	  transform: translateY(-100%);
	  opacity: 0;
	}
	to {
	  transform: translateY(0);
	  opacity: 1;
	}
  }
  
  .success-icon {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: white;
	color: #00c853;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	flex-shrink: 0;
  }
  
  .success-text {
	flex: 1;
	font-size: 16px;
	line-height: 1.4;
	font-weight: 500;
  }
  
  /* 顶部标题栏 */
  .header-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 25px 16px;
	background: url(/img/header.svg) no-repeat 50%/100%;
	position: relative;
	z-index: 10;
	height: 3rem;
  }
  
  .back-btn {
	font-size: 28px;
	background: none;
	border: none;
	color: white;
	cursor: pointer;
  }
  
  .title-center {
	text-align: center;
	flex: 1;
  }
  
  .subtitle {
	font-size: 18px;
	opacity: 0.8;
  }
  
  .main-title {
	font-size: 30px;
	font-weight: bold;
  }
  
  .record-btn {
	display: flex;
	align-items: center;
	gap: 6px;
	background: #ec4899;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 20px;
	font-size: 20px;
	cursor: pointer;
  }
  
  /* 背景图 */
  .bg-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: url('http://www.desire-club.top/xuanfei/20241022/7bf5bf8a20b306cf1706f8d9eab4b76c.jpg') no-repeat center center;
	background-size: cover;
	filter: blur(2px);
	opacity: 0.4;
	z-index: 0;
  }
  
  /* 认证区域包装器 */
  .auth-wrapper {
	position: relative;
	width: 100%;
	min-height: 800px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 0;
	z-index: 5;
	pointer-events: none;
  }
  
  .auth-wrapper > * {
	pointer-events: auto;
  }

  /* 中心认证按钮 */
  .center-auth {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 5;
  }
  
  .auth-circle {
	width: 380px;
	height: 380px;
	border-radius: 50%;
	background: #000;
	border: 8px solid #ec4899;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 20px rgba(236, 72, 153, 0.6);
	position: relative;
  }
  
  .shield-icon {
	font-size: 48px;
	margin-bottom: 12px;
  }
  
  .auth-text {
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 10px;
  }
  
  .time-label {
	font-size: 16px;
	background: #7c1d4f;
	padding: 6px 12px;
	border-radius: 12px;
	margin-bottom: 8px;
  }
  
  .countdown {
	font-size: 32px;
	font-weight: bold;
	color: #ec4899;
	transition: color 0.3s;
  }
  
  .countdown-zero {
	color: #ff4444;
	animation: blink 1s infinite;
  }
  
  @keyframes blink {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.5; }
  }
  
  .refresh-tip {
	font-size: 14px;
	color: #ff4444;
	margin-top: 8px;
  }
  
  /* 订单进度卡片 */
  .order-progress-card {
	position: relative;
	margin: 20px 16px;
	background: rgba(0, 0, 0, 0.85);
	border: 2px solid #ec4899;
	border-radius: 12px;
	padding: 20px;
	z-index: 10;
	max-width: 96%;
	margin-left: auto;
	margin-right: auto;
  }
  
  .progress-title {
	font-size: 20px;
	font-weight: bold;
	color: #ec4899;
	margin-bottom: 16px;
	text-align: center;
  }
  
  .progress-steps {
	display: flex;
	flex-direction: column;
	gap: 12px;
  }
  
  .progress-step-item {
	padding: 12px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 8px;
	border: 2px solid transparent;
	transition: all 0.3s;
  }
  
  .progress-step-item.active {
	border-color: #ec4899;
	background: rgba(236, 72, 153, 0.1);
  }
  
  .progress-step-item.completed {
	border-color: #00c853;
	background: rgba(0, 200, 83, 0.1);
  }
  
  .step-name {
	font-size: 18px;
	font-weight: bold;
	color: #fff;
	margin-bottom: 8px;
  }
  
  .step-progress {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 6px;
  }
  
  .progress-text {
	font-size: 16px;
	color: #ec4899;
	font-weight: bold;
	min-width: 60px;
  }
  
  .progress-bar {
	flex: 1;
	height: 8px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 4px;
	overflow: hidden;
  }
  
  .progress-fill {
	height: 100%;
	background: linear-gradient(90deg, #ec4899, #ff6b9d);
	border-radius: 4px;
	transition: width 0.3s;
  }
  
  .step-status {
	font-size: 14px;
	color: #aaa;
	margin-top: 4px;
  }
  
  .step-status.waiting {
	color: #ffa726;
  }
  
  .step-status.completed {
	color: #00c853;
	font-weight: bold;
  }
  
  /* 产品按钮 - 绝对定位围绕中心圆形 */
  .action-item {
	position: absolute;
	background: rgba(0, 0, 0, 0.7);
	border: 3px solid #8b8b8b;
	border-radius: 16px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	width: 150px;
	min-height: 150px;
	transition: all 0.3s;
	z-index: 6;
	margin-top:50px;
  }

  .action-item.active {
	background: rgba(236, 72, 153, 0.3);
	border-color: #ec4899;
	box-shadow: 0 0 25px rgba(236, 72, 153, 0.7);
	transform: scale(1.05);
  }

  .action-item:active {
	transform: scale(0.95);
  }

  /* 产品位置 */
  .product-top-left {
	top: 30px;
	left: 30px;
  }

  .product-top-right {
	top: 30px;
	right: 30px;
  }

  .product-bottom-left {
	bottom: 0;
	left: 30px;
  }

  .product-bottom-right {
	bottom: 0;
	right: 30px;
  }
  
  .action-icon {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	margin-bottom: 12px;
  }
  
  .action-label {
	font-size: 18px;
	font-weight: 500;
  }
  
  /* 积分输入区域 */
  .points-section {
	background: #000;
	border: 2px solid #ec4899;
	border-radius: 12px;
	padding: 25px;
	margin: 20px 16px;
	z-index: 10;
	position: relative;
	/* margin-bottom: 150px; */
  }
  
  .points-input {
	width: 100%;
	padding: 20px;
	background: transparent;
	border: 2px solid #ec4899;
	border-radius: 8px;
	color: white;
	font-size: 28px;
	text-align: left;
	outline: none;
	font-weight: bold;
	box-sizing: border-box;
	position: relative;
	z-index: 11;
	pointer-events: auto;
  }
  
  .points-input::placeholder {
	color: #666;
	font-size: 28px;
  }
  .progress-hr {
	margin-top: 40px;
	margin-bottom: 40px;
	border: none;
	border-top: 0.5px dashed #7c7c7c;
  }
  .info-row {
	font-size: 24px;
	color: #aaa;
	margin-top: 20px;
	line-height: 1.6;
	text-align: left;
  }
  
  .balance-btn-row {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	margin-top: 30px;
	gap: 16px;
  }
  
  .balance-row {
	display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    font-size: 3.2vw;
    justify-content: space-evenly;
  }
  
  .balance-value {
	font-size: 38px;
	font-weight: bold;
	color: #ec4899;
	margin-top: 0px;
  }
  
  .confirm-btn {
	width: 100%;
	padding: 22px 30px;
	background: linear-gradient(90deg,#df35ad,#4f1db5);
	border: none;
	border-radius: 24px;
	color: white;
	font-weight: bold;
	font-size: 32px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	white-space: nowrap;
  }
  
  /* 底部导航栏 */
  .footer-nav {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: none;
	border-top: 2px solid #ec4899;
	display: flex;
	justify-content: space-around;
	padding: 8px 0;
	z-index: 100;
  }
  
  .nav-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
	font-size: 16px;
	color: #fff;
	cursor: pointer;
	transition: color 0.2s;
	background: none;
    border: none;
  }
  
  .nav-item.active {
	color: #ec4899;
  }
  
  .nav-icon {
	font-size: 28px;
	margin-bottom: 6px;
  }
  
  .nav-text {
	font-size: 28px;
  }
  </style>
  
  <style>
  /* 全局隐藏滚动条 - 最彻底的方法 */
  * {
	scrollbar-width: none !important; /* Firefox */
	-ms-overflow-style: none !important; /* IE 和 Edge */
  }
  
  *::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
	display: none !important;
	background: transparent !important;
  }
  
  *::-webkit-scrollbar-track {
	display: none !important;
	background: transparent !important;
  }
  
  *::-webkit-scrollbar-thumb {
	display: none !important;
	background: transparent !important;
  }
  
  *::-webkit-scrollbar-corner {
	display: none !important;
	background: transparent !important;
  }
  
  html, body {
	scrollbar-width: none !important;
	-ms-overflow-style: none !important;
	overflow-x: hidden !important;
  }
  
  html::-webkit-scrollbar,
  body::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
	display: none !important;
	background: transparent !important;
  }
  
  html::-webkit-scrollbar-track,
  body::-webkit-scrollbar-track {
	display: none !important;
	background: transparent !important;
  }
  
  html::-webkit-scrollbar-thumb,
  body::-webkit-scrollbar-thumb {
	display: none !important;
	background: transparent !important;
  }
  </style>
  